import i18n from '../../i18n';
import { filterTypes } from './mapFilters';

const t = (key: string) => i18n.t(key) as unknown as string;

export const serviceTypes = {
  workshop: 'warsztaty',
  summerplay: 'polkolonie',
  academy: 'akademia',
  birthday: 'urodziny',
  one_time_workshop: 'warsztaty-jednorazowe'
} as const;

export const services = [
  {
    type: 'service',
    value: serviceTypes.workshop,
    title: t('services.warsztaty.title'),
    description: t('services.warsztaty.description'),
    disabled: false,
    mapFilters: [
      filterTypes.vacancy,
      filterTypes.firstLesson,
      filterTypes.setDate,
    ],
    highlighted: true,
  },
  {
    type: 'service',
    value: serviceTypes.summerplay,
    title: t('services.polkolonie.title'),
    description: t('services.polkolonie.description'),
    disabled: false,
    mapFilters: [],
  },
  {
    type: 'service',
    value: serviceTypes.birthday,
    title: t('services.urodziny.title'),
    description: t('services.urodziny.description'),
    disabled: false,
    mapFilters: [],
  },
  {
    type: 'service',
    value: serviceTypes.one_time_workshop,
    title: t('services.oneTimeWorkshop.title'),
    description: t('services.oneTimeWorkshop.description'),
    disabled: false,
    mapFilters: [],
  },
  // {
  //   type: "service",
  //   value: serviceTypes.academy,
  //   title: "Letnia Przygoda w Akademii Robotyki",
  //   description: "5 dni programowania i zabawy w ferie i wakacje",
  //   disabled: false,
  //   mapFilters: [],
  // },
];
